import styled, { css } from "styled-components";
import { globalContainer, mainColor, additionalColor } from "../../root/global";
import { Link } from "react-router-dom";

export const HeaderWrapper = styled.header`
  position: relative;
  z-index: 100;
`;

export const HeaderContainer = styled.div`
  ${globalContainer};
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding-top: 40px;

  @media screen and (max-width: 767px) {
    position: relative;
    z-index: 30;
    justify-content: space-between;
    padding-top: 22px;
    padding-bottom: 22px;
  }
`;

export const Brand = styled(Link)`
  display: none;
  text-decoration: none;
  color: ${mainColor};
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.3px;

  @media screen and (max-width: 767px) {
    display: block;
  }
`;

export const NavLinks = styled.nav`
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex: 1;

  @media screen and (max-width: 767px) {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 20;
    flex: none;
    flex-direction: column;
    align-items: stretch;
    background: #fff;
    border-radius: 0 0 18px 18px;
    box-shadow: 0 20px 40px rgba(40, 52, 74, 0.18);
    overflow: hidden;
    max-height: ${({ $isOpen }) => ($isOpen ? "320px" : "0")};
    opacity: ${({ $isOpen }) => ($isOpen ? "1" : "0")};
    transform: translateY(${({ $isOpen }) => ($isOpen ? "0" : "-8px")});
    transition: max-height 0.35s ease, opacity 0.25s ease, transform 0.25s ease;
    pointer-events: ${({ $isOpen }) => ($isOpen ? "auto" : "none")};
  }
`;

export const HeaderLink = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  color: ${mainColor};
  font-size: 20px;
  font-weight: 500;
  transition: 0.3s linear;
  position: relative;
  z-index: 1;

  &:hover {
    transform: translateY(-5px);
  }

  @media screen and (max-width: 767px) {
    width: 100%;
    padding: 16px 28px;
    font-size: 17px;
    font-weight: 600;
    letter-spacing: 0.3px;
    border-bottom: 1px solid rgba(40, 52, 74, 0.08);
    transform: none !important;

    &:last-child {
      border-bottom: none;
    }

    &:active {
      background: rgba(134, 67, 220, 0.08);
      color: ${additionalColor};
    }
  }
`;

export const MenuToggle = styled.button`
  display: none;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  width: 40px;
  height: 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;

  span {
    display: block;
    width: 24px;
    height: 2px;
    border-radius: 2px;
    background: ${mainColor};
    transition: transform 0.3s ease, opacity 0.3s ease;
  }

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      span:nth-child(1) {
        transform: translateY(7px) rotate(45deg);
      }
      span:nth-child(2) {
        opacity: 0;
      }
      span:nth-child(3) {
        transform: translateY(-7px) rotate(-45deg);
      }
    `}

  @media screen and (max-width: 767px) {
    display: flex;
  }
`;

export const Overlay = styled.div`
  display: none;

  @media screen and (max-width: 767px) {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(20, 24, 34, 0.45);
    opacity: ${({ $isOpen }) => ($isOpen ? "1" : "0")};
    visibility: ${({ $isOpen }) => ($isOpen ? "visible" : "hidden")};
    transition: opacity 0.25s ease, visibility 0.25s ease;
    z-index: 10;
  }
`;
